import { signal, ChangeDetectionStrategy } from '@angular/core';
import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { LoginService } from './services/login.service';
import { EbayService } from './services/ebay.service';
import { isPlatformBrowser } from '@angular/common';
import { ConfigService } from './services/config.service';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected readonly title = signal('msar-dash');
  private translate = inject(TranslateService);
  private ebaySrv = inject(EbayService);
  private configService = inject(ConfigService);
  constructor(
    private router: Router,
    private csrfService: LoginService,
  ) {}

  platformId = inject(PLATFORM_ID);

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.csrfService.refreshCsrfToken().subscribe({
        next: () => {
          this.configService.loadConfig();
          this.translate.addLangs(['de', 'en']);
          this.translate.setFallbackLang('de');
          this.translate.use('de');
          this.csrfService.checkLogin();
          this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
              window.scrollTo(0, 0);
            }
          });
        },
        error: () => {
          this.csrfService.logout();
          this.router.navigateByUrl('/');
        },
      });
    }
  }
}
